import { useState } from "react";
import OutlinedInputElement from "./OutlinedInputElement";

type Props = any

export default function OtpInput({ disabled, onChange, autoFocus, endAdornment, hiddenPaddingRight }: Props) {
    const [value, setValue] = useState('')
    const [show, setShow] = useState(false)

    const handleChangeInput = (e) => {
        const valueInput = e?.target?.value ?? ''
        setValue(valueInput)
        onChange && onChange(valueInput)
    }

    const handleChangeShow = () => {
        setShow((prev) => !prev)
    }

    return (
        <div>
            <OutlinedInputElement
                sx={hiddenPaddingRight ? { paddingRight: 0 } : {}}
                fullWidth={true}
                // className={!show && "font-password"}
                autoFocus={autoFocus ?? false}
                autoComplete={"off"}
                size='small'
                value={disabled !== null ? (!disabled ? value : "•••••••") : value}
                onChange={(e) => handleChangeInput(e)}
                endAdornment={endAdornment ?? null}
            />
        </div>
    )
}